<div class="">
  <div class="w-full flex gap-4">
    <div
      class="flex-1 rounded-lg p-4 flex items-center gap-3 cursor-pointer transition-colors duration-200"
      [class]="
        selectedOption === 'avis'
          ? 'bg-blue-50 dark:bg-blue-200/20 border border-blue-200 dark:border-blue-200'
          : 'bg-white dark:bg-zinc-800 border border-gray-200 dark:border-zinc-600 hover:bg-blue-50 dark:hover:bg-blue-200/10 hover:border-blue-200 dark:hover:border-blue-100'
      "
      (click)="selectOption('avis')"
    >
      <div
        [class]="
          selectedOption === 'avis'
            ? 'bg-blue-100 dark:bg-blue-800'
            : 'bg-gray-100 dark:bg-zinc-600'
        "
        class="p-1 rounded-lg transition-colors duration-200"
      >
        <lucide-icon
          name="bell"
          class="w-6 h-6 text-emerald-600 dark:text-emerald-400"
        ></lucide-icon>
      </div>
      <div>
        <p class="text-sm text-gray-600 dark:text-zinc-300">Avis de travail</p>
        <p class="text-2xl font-bold text-gray-900 dark:text-white">{{totalWorkNotificationRecords}}</p>
      </div>
    </div>

    <div
      class="flex-1 rounded-lg p-4 flex items-center gap-3 cursor-pointer transition-colors duration-200"
      [class]="
        selectedOption === 'doublons'
          ? 'bg-blue-50 dark:bg-blue-200/20 border border-blue-200 dark:border-blue-200'
          : 'bg-white dark:bg-zinc-800 border border-gray-200 dark:border-zinc-600 hover:bg-blue-50 dark:hover:bg-blue-200/10 hover:border-blue-200 dark:hover:border-blue-100'
      "
      (click)="selectOption('doublons')"
    >
      <div
        [class]="
          selectedOption === 'doublons'
            ? 'bg-blue-100 dark:bg-blue-800'
            : 'bg-gray-100 dark:bg-zinc-600'
        "
        class="p-2 rounded-lg transition-colors duration-200"
      >
        <lucide-icon
          name="pickaxe"
          class="w-6 h-6 text-red-600 dark:text-red-400"
        ></lucide-icon>
      </div>
      <div>
        <p class="text-sm text-gray-600 dark:text-zinc-300">Ordre de travail</p>
        <p class="text-2xl font-bold text-gray-900 dark:text-white">
          {{ totalWorkOrderRecords }}
        </p>
      </div>
    </div>


  </div>
</div>

<!-- Two Column Layout -->
<div class="w-full flex gap-4 mt-3 w-full">
  <!-- Avis de travail View -->
  <app-work-notification 
    class="w-full" 
    [class.hidden]="selectedOption !== 'avis'"
    [plantOptions]="plantOptions"
    [mainWorkCenterOptions]="mainWorkCenterOptions"
    (totalRecordsChange)="totalWorkNotificationRecords = $event">
  </app-work-notification>

  <!-- Ordre de travail Table -->
  <app-work-order 
    class="w-full"
    [class.hidden]="selectedOption !== 'doublons'"
    [plantOptions]="plantOptions"
    [mainWorkCenterOptions]="mainWorkCenterOptions"
    (totalRecordsChange)="totalWorkOrderRecords = $event">
  </app-work-order>
</div>
